import { render, staticRenderFns } from "./custom-components.page.vue?vue&type=template&id=cec18418&scoped=true&"
import script from "./custom-components.page.vue?vue&type=script&lang=js&"
export * from "./custom-components.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec18418",
  null
  
)

export default component.exports